/** @file createPuppet: creates a puppet in a project from a ready New puppet draft (scope, then the profile). */
import type { EditorApi } from '../store/editorApi';
import type { ReadyDraft } from './newPuppetTypes';

/** The new puppet's id, and a warning when the profile could not be set (the puppet exists either way). */
export type CreatedPuppet = { id: string; warning: string | null };

/**
 * `puppets.create { project, name, kind: puppet, template, scope }`; the create body has no profile (W6 plan), so a
 * profile other than the template's own is set after with `puppet.setProfile` (its `-side` twin for the side camera,
 * as the scope does for the template's profile).
 */
export async function createPuppet(api: EditorApi, projectId: string, d: ReadyDraft, templateProfile: string): Promise<CreatedPuppet> {
  const scope = { directions: d.directions, pitch: d.pitch, camera: d.camera };
  const { id } = await api.puppets.create({ project: projectId, name: d.name.trim(), kind: 'puppet', template: d.template, scope });
  if (d.profile === templateProfile.replace(/-side$/, '')) return { id, warning: null };
  const profile = d.camera === 'side' ? `${d.profile}-side` : d.profile;
  const reply = await api.puppets.commands(id, { commands: [{ name: 'puppet.setProfile', input: { profile } }] });
  const failed = reply.replies.find((r) => !r.ok);
  return { id, warning: failed?.ok === false ? `Created, but the profile stays the template's: ${failed.error.message}` : null };
}
